<template>
  <div v-loading="loading">
    <div class="title">岗位任务</div>
    <div class="mb-12">
      <el-select
        class="w-120 mb-12 mr-12"
        v-model="status"
        size="medium"
        placeholder="状态"
        clearable
      >
        <el-option label="建设中" :value="1"></el-option>
        <el-option label="已提交" :value="2"></el-option>
        <el-option label="已完成" :value="3"></el-option>
      </el-select>
      <el-input
        class="w-200 mb-12 mr-12"
        placeholder="岗位名称"
        prefix-icon="el-icon-search"
        v-model.trim="name"
        size="medium"
        clearable
        @keyup.enter.native="search"
      >
      </el-input>
      <el-button type="primary" size="medium" plain @click="search"
        >查询</el-button
      >
      <el-button size="medium" @click="clearSearch">重置</el-button>
      <div style="float: right">
        <el-link size="small" icon="el-icon-question">指南</el-link>
      </div>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="60" label="编号" prop="id"></el-table-column>
      <el-table-column
        width="120"
        label="岗位名称"
        prop="skill_model.industry_job.name"
      ></el-table-column>
      <el-table-column
        width="120"
        label="岗位方向"
        prop="skill_model.industry_job.parent.name"
      ></el-table-column>
      <el-table-column
        width="120"
        label="岗位类别"
        prop="skill_model.industry_job.parent.category.name"
      ></el-table-column>
      <el-table-column
        width="120"
        label="行业"
        prop="skill_model.industry_job.parent.category.industry.name"
      ></el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>任务单价</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.unit_price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="80" label="任务状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">建设中</span>
          <span v-if="scope.row.status === 2">已提交</span>
          <span v-if="scope.row.status === 3">已完成</span>
        </template>
      </el-table-column>
      <el-table-column width="120" label="预期完成时间">
        <template slot-scope="scope">
          <div v-if="scope.row.expected_finish_date">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{
              scope.row.expected_finish_date
            }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column width="120" label="完成时间">
        <template slot-scope="scope">
          <div v-if="scope.row.real_finish_at">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{
              scope.row.real_finish_at
            }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column width="80" label="设计师">
        <template slot-scope="scope">
          <span v-if="scope.row.teacher.realname">{{
            scope.row.teacher.realname
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column width="55" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="goDetail(scope.row.id)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import postService from "@/global/service/post";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    ShowHideContent
  },
  data() {
    return {
      loading: true,
      isShow: false,
      name: null,
      status: null,
      list: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      const query = this.$route.query;
      const page = Number(query.page) || 1;
      const page_size = Number(query.size) || 20;
      const name = query.name;
      const status = query.status ? Number(query.status) : null;
      const params = {
        page,
        page_size,
        name,
        status
      };
      this.loading = true;
      postService
        .postList(params)
        .then(res => {
          this.list = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
          this.pagination.pageSize = page_size;
          this.name = name;
          this.status = status;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goDetail(id) {
      this.$router.push({
        name: "PostTaskDetail",
        params: { id }
      });
    },
    goPage(val) {
      const query = {
        page: val
      };
      const size = this.$route.query.size;
      if (size) query.size = size;
      if (this.name || this.status) {
        if (this.name) {
          query.name = this.name;
        }
        if (this.status) {
          query.status = this.status;
        }
      }
      this.$router.push({
        name: "PostTaskSelf",
        query
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    search() {
      const size = this.$route.query.size;
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "PostTaskSelf",
          query: {}
        });
      }
      if (size || this.name || this.status) {
        const query = {};
        if (size) query.size = size;
        if (this.name) {
          query.name = this.name;
        }
        if (this.status) {
          query.status = this.status;
        }
        this.$router.push({
          name: "PostTaskSelf",
          query
        });
      } else {
        this.getData();
      }
    },
    clearSearch() {
      this.name = null;
      this.status = null;
      const size = this.$route.query.size;
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "PostTask",
          query: {}
        });
      }
      if (size) {
        this.$router.push({
          name: "PostTask",
          query: { size }
        });
      } else {
        this.getData();
      }
    }
  }
};
</script>
